'use strict'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  getUser(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addUser(userInfo) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/users', userInfo)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateUserPermissions(userId, permissions) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/users/${userId}/permissions`, permissions)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateUser(userId, userInfo) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/users/${userId}`, userInfo)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteUser(userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/users/${userId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getMyResellerGroups(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}/groups`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },

  getMyCustomerGroups(userId, groupId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}/groups/${groupId}/children`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getMyCompany(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}/company`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addGroup(userId, group) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/users/${userId}/groups`, group)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateGroup(userId, group, groupId) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/users/${userId}/groups/${groupId}`, group)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteGroup(userId, groupId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/users/${userId}/groups/${groupId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getAvailableTestMethods(userId, groupId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}/groups/${groupId}/testmethods`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateAvailableTestMethods(userId, groupId, testMethods) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/users/${userId}/groups/${groupId}/testmethods`, testMethods)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getAvailableScales(userId, questionFormat, languageId, defaultLanguageId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/users/${userId}/questionformat/${questionFormat}/scales?languageId=${languageId}&defaultLanguageId=${defaultLanguageId}`
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getCustomTestMethods(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}/customtestmethod`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getCustomTestMethod(userId, testMethod, languageId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/users/${userId}/customtestmethod/${
            testMethod.id
          }?languageId=${languageId}`
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addCustomTestMethod(userId, testMethod, languageId) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api/users/${userId}/customtestmethod?languageId=${languageId}`,
          testMethod
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateCustomTestMethod(userId, testMethod, languageId) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/api/users/${userId}/customtestmethod/${
            testMethod.id
          }?languageId=${languageId}`,
          testMethod
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteCustomTestMethod(userId, testMethod) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/users/${userId}/customtestmethod/${testMethod.id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getAvailableNormGroups(userId, groupId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}/groups/${groupId}/availablenormgroups`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getCustomerTags(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}/customertags`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addCustomerTag(userId, tag) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/users/${userId}/customertags`, tag)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateCustomerTag(userId, tag) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/users/${userId}/customertags/${tag.id}`, tag)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteCustomerTag(userId, tag) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/users/${userId}/customertags/${tag.id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getMailTemplates(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${userId}/mailtemplates`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addMailTemplate(userId, mailTemplate) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/users/${userId}/mailtemplates`, mailTemplate)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateMailTemplate(userId, mailTemplate) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/api/users/${userId}/mailtemplates/${mailTemplate.id}`,
          mailTemplate
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteMailTemplate(userId, mailTemplate) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/users/${userId}/mailtemplates/${mailTemplate.id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getCreditTransactions(userId, groupId, dateFrom, dateTo) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/users/${userId}/groups/${groupId}/credittransactions?dateFrom=${dateFrom}&dateTo=${dateTo}`
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
